module.exports = __webpack_public_path__ + "img/58_10.269e75e9.png";